import { Store } from "redux";
import { SDK } from "@sdk";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { SuppliersSlice } from "./suppliers.slice";
import { iSupplier } from "@sdk/suppliers/supplier-model";
import { suppliersDefaultQueryConfig } from "./suppliers-default-query";

export const {
  loadEntityQueries: loadSuppliersQuery,
  loadEntityById: loadSupplierById,
  loadMoreEntityQueries: loadMoreSuppliersQueries,
} = CreateHelpersForEntity<iStore, iSupplier>({
  sliceName: "suppliers",
  slice: SuppliersSlice,
  isPaginatedQueries: true,
  fetchPageSize: 500,
  loadEntityQueryProvider: (query) => SDK.suppliers.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.suppliers.getById(entityId),
});

export const LoadAllSuppliers = (store: Store<iStore>, forceReload?: boolean) =>
  loadSuppliersQuery(suppliersDefaultQueryConfig, "all")(store, forceReload);

export const LoadSuppliersByBrand = (
  brandId: string,
  store: Store<iStore>,
  forceReload?: boolean
) => {
  const queryConfig = {
    query: { brandId },
    options: { sortBy: ["createdAt"] },
  };
  return loadSuppliersQuery(queryConfig, `byBrand:${brandId}`)(
    store,
    forceReload
  );
};
